import gql from 'graphql-tag'

const stockAdviceItemsGetQuery = gql`
  query stockAdviceItemsGet($offset: Int, $limit: Int, $criteria: Object, $sorting: Object, $nested: Boolean) {
    stockAdviceItemsGet(input: { limit: $limit, offset: $offset, criteria: $criteria, sort: $sorting, nested: $nested })
      @rest(type: "StockAdviceItemsResult", method: "POST", path: "stock-advice-item/list") {
      results
      paging
    }
  }
`

export default stockAdviceItemsGetQuery
